import { type ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSessionFeatures } from '@/entities/auth';

import * as route from '@/shared/constants/router';

interface FeatureAccessGuardProps {
    requiredFeature: string;
    children: ReactNode;
    noRedirect?: boolean;
}

// This wrapper protects routes or layouts that require a specific subscription feature.
// If the user does not possess the feature, they are redirected to the dashboard and a
export function FeatureAccessGuard({
    requiredFeature,
    children,
    noRedirect = false,
}: FeatureAccessGuardProps) {
    const navigate = useNavigate();
    const sessionFeatures = useSessionFeatures();

    const hasAccess = sessionFeatures.includes(requiredFeature);

    useEffect(() => {
        if (!hasAccess && !noRedirect) {
            navigate(route.getDashboardPath(), { replace: true });
            // eslint-disable-next-line no-alert
            window.alert('Access denied');
        }
    }, [hasAccess, navigate, noRedirect]);

    if (!hasAccess) {
        return null;
    }

    return children;
}
